(function() { window.GUID_d246d5a1_f838_4554_90d9_041fa28b1624 = { getGuid: function() { return "d246d5a1-f838-4554-90d9-041fa28b1624"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PromotionDisplayPeriodId;
        (function (PromotionDisplayPeriodId) {
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["Start"] = 1] = "Start";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["Middle"] = 2] = "Middle";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["NearEnd"] = 3] = "NearEnd";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["End"] = 4] = "End";
            PromotionDisplayPeriodId[PromotionDisplayPeriodId["ImmediatelyAfterEnd"] = 5] = "ImmediatelyAfterEnd";
        })(PromotionDisplayPeriodId = Enumeration.PromotionDisplayPeriodId || (Enumeration.PromotionDisplayPeriodId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PromotionDisplayPeriodId.pre.js.map
